// Один запрос к источнику карточки: ждём / отказ / данные.
//
// ЗАЧЕМ СВОЙ ХУК, А НЕ react-query. Хуки react-query в этом проекте настроены на BFF
// (`api/hooks.ts`) и на ключи запросов Bitrix. Карточка ходит не в BFF, а в ИСТОЧНИК,
// который сегодня поддельный, а завтра будет своей схемой; заводить под него параллельный
// набор ключей значило бы завести второй кеш с теми же именами. Когда транспорт появится,
// этот хук заменится обычным `useQuery` — и это одна правка в одном файле.
//
// ТРИ ОТВЕТА, А НЕ ДВА. `данные === null && ждём` — «ещё не знаем»; `отказ` — «спросили и
// не получили»; пустой массив — «спросили и получили ноль». Слить их в один означало бы
// напечатать «вложений нет» там, где источник просто не ответил.

import { useEffect, useState } from 'react'
import type { DependencyList } from 'react'

export interface Ответ<T> {
  данные: T | null
  отказ: string | null
  ждём: boolean
}

export function useИсточник<T>(взять: () => Promise<T>, зависимости: DependencyList): Ответ<T> {
  const [данные, setДанные] = useState<T | null>(null)
  const [отказ, setОтказ] = useState<string | null>(null)
  const [ждём, setЖдём] = useState(true)

  useEffect(() => {
    let брошен = false
    setЖдём(true)
    setОтказ(null)
    взять()
      .then((р) => { if (!брошен) setДанные(р) })
      .catch((е: Error) => { if (!брошен) { setДанные(null); setОтказ(е.message) } })
      .finally(() => { if (!брошен) setЖдём(false) })
    return () => { брошен = true }
    // Зависимости задаёт вызывающий: он знает, что именно меняет запрос.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, зависимости)

  return { данные, отказ, ждём }
}
